import { React, useState, useEffect } from "react";
import "./landing.css";
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import image from "./img/switch.png";
import logoutimg from "./img/logout.png";
import imagebk from "./img/back.png";
import Softwareaccess from '../../Pages/SoftwareAccess';
import Vpnaccess from '../../Pages/VPNRequest';
import Sharepoint from '../../Pages/SharepointAccess';	
import Vendormaster from '../../Pages/AccessreqVendor';									
import { CREATE_USB_ACCESS,GET_SAVEDUSBREQUEST } from '../../Pages/AppConstant'
function Landing() {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [contact, setContact] = useState("");
    const [pan, setPan] = useState("");
    const [bod, setBod] = useState("");
    const [doj, setDoj] = useState("");
    const [requestorname, setRequestorname] = useState("");
    const [requestdept, setRequestdept] = useState("");
    const [purpose, setPurpose] = useState("");
    const [asset_id, setAsset_id] = useState("");
    const [selectedrpmanager, setSelectedrpmanager] = useState("");
    const [ifchecked, setIfchecked] = useState(false);
    const [selectedtext, setSelectedtext] = useState("");
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    const [mindateset, setMindateset] = useState("")
	const [selectaccessrequest,setSelectaccessrequest]= useState("")
    const [isfirsttab,setIsfirsttab]= useState(true);
    const [issecondtab,setIssecondtab]= useState(false);
    const [usblist,setUsblist] = useState([]);

    const calltosetmindate = () => {
        setSelectedrpmanager(localStorage.getItem('functionheademail'))
        let month;
        let day;
        if ((new Date().getMonth() + 1) < 10) {
            month = "0" + (new Date().getMonth() + 1)
        } else {
            month = (new Date().getMonth() + 1)
        }
        if (new Date().getDate() < 10) {
            day = "0" + new Date().getDate()
        } else {
            day = new Date().getDate()
        }
        let date = new Date().getFullYear() + '-' + month + '-' + day;
        setMindateset(date);
    }

    useEffect(() => {
        calltosetmindate();
        getsession();
    }, []);

    const getsession=()=>{
        if(localStorage.getItem('sessions')!=="isactive"){
            window.location.href = "/"
        }       
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        if (!purpose || !asset_id || !selectedrpmanager) {
            alert("Please fill all the fields")
        } else {
            if (ifchecked) {
                getUserData();
            } else {
                alert("Please select the agreed checkbox")
            }

        }

        // Add your form submission logic here

    };

    const redirectToLogin = () => {
        window.location.href = "/login"
    }

    const handleReset = () => {
        // Reset all state variables here
        setRequestdept("");
        setRequestorname("");
        setPurpose("");
        setAsset_id("");
        setSelectedrpmanager("")
        setIfchecked(false)
        const Checkboxes = document.getElementById('checkboxs');
        if (Checkboxes.checked === true) {
            Checkboxes.checked = false
        }

    };
    const getUserData = () => {

        let empid=  localStorage.getItem('empid');
        let rqdept= localStorage.getItem('dept');
        let reason = purpose
        let assetid = asset_id
        let fhemailid = localStorage.getItem('functionheademail')
        let empemailid = localStorage.getItem('emailid');
        let empname = localStorage.getItem('empname');
        let fhname = localStorage.getItem('functionheadname');
        let startdate = start;
        let enddate = end;



        axios.post(CREATE_USB_ACCESS, { empid, rqdept, reason, assetid, fhemailid, empemailid, fhname, empname, startdate, enddate })
            .then(function (response) {
                //console.log("SuccessFully updated");
                alert(response.data);
                handleReset();


            })
            .catch(function (error) {
                console.log(error);
            });

    }
    const redirectTodashboard = () => {
        window.location.href = "/landingPage"
    }

    const checkedval = (e) => {
        if (e.currentTarget.checked === true) {
            setIfchecked(true)
        } else {
            setIfchecked(false)
        }

    }
    const callselectedfn = (e) => {
        setSelectedrpmanager(e.target.value)
        setSelectedtext(e.target.options[e.target.selectedIndex].innerText)
    }
    const callinputsetfn = (e) => {
        if (e.target.value.length > 6) {
            alert("Employee ID cannot exceed 6 digit")

        } else {
            setRequestorname(e.target.value)
        }

    }
    const isAlpha = checkvalue => /^[a-zA-Z]*$/.test(checkvalue)
    const assetentryfn = (e) => {
        let checkvalue = e.target.value
        if (e.target.value.length === 12) {
            let strRegex = new RegExp(/^[A-Za-z]+$/i);
            let result1 = strRegex.test(checkvalue);
            let strRegex2 = new RegExp(/^[0-9]+$/i);
            let result2 = strRegex2.test(checkvalue);
            if (result1 || result2 === true) {
                alert("Should contain alphanumeric")
            }

        }
        setAsset_id(e.target.value)
    }
	const callselectrequest=(e)=>{
        setSelectaccessrequest(e.target.value)
    }
    const enabletab=(e)=>{
        if(e===2){
            setIsfirsttab(false)
            setIssecondtab(true)
            callsaveddata()
        }else{
           
            setIsfirsttab(true)
            setIssecondtab(false)
        }
       }
    const callsaveddata=()=>{
                   axios({
                       method: "get",
                       url: GET_SAVEDUSBREQUEST,
                       withCredentials: false,
                       headers: {
                         "Content-Type": "application/x-www-form-urlencoded",
                         "Access-Control-Allow-Origin": "*",
                       },
                       params:{"emp_id" : localStorage.getItem('empid')}
                     })
                       .then((response) => {
                           // setsavedvendorraw(response.data.data)
                           setUsblist(response.data.data);
                       })
                       .catch((error) => {
                         console.error(error);
                       });
               }							  
    return (
         <div className="bg_set_usb">   
         <div className="switch" >
                    <img className="switch-back" onClick={redirectTodashboard} src={imagebk}/>
                    <img className="switch-img" src={image}/>
                    <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
                </div><br/><br/>         
             <div>
            </div>
            <div>
        <div className={selectaccessrequest==="5"?"apps_vendor":selectaccessrequest==="2"?"apps_sws":selectaccessrequest==="0"?"apps_sws":"Apps"}>
            <p className="Headings">Access Request</p>
            <fieldset>
				 
            <div className={selectaccessrequest==="5"?"col-md-2":selectaccessrequest==="2"?"col-md-2":"col-md-6"} ><label>Select Access Request</label>
                    <select
                        name="select"
                        id="select"
                        value={selectaccessrequest}
                        onChange={(e) =>callselectrequest(e)}
                    >
                        <option
                            value=""
                            disabled
                            selected={selectaccessrequest === ""}
                        >
                            Access Request
                        </option>                        
                            <option value="0">USB Access</option>
                            <option value="1">VPN Request</option>
                            <option value="2">Software Request</option>
                            <option value="4">External Sharing</option>  
                             {/* <option value="5">Vendor Master</option> */}
 
                            {/* <option value="3">Others</option> */}																																																							 
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>
               {selectaccessrequest==="0" & isfirsttab?<div><form action="#" method="get">
                <div className="row">
                   
                    </div>
                    <div className="row">
                         <div className="row ">
                        <div className={isfirsttab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(1)}>Creation</div>  
                        <div className={issecondtab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(2)}>View </div> 
                    </div>
                    <div className="col-md-12">
                    <label for="firstname">
                    Purpose for activation of USB Portss
                    </label>
                    <input
                        type="text"
                        name="firstname"
                        id="firstname"
                        value={purpose}
                        onChange={(e) =>
                            setPurpose(e.target.value)
                        }
                        placeholder="Purpose for activation"
                        required
                    />
                    </div>
                    <div className="col-md-6"> <label for="lastname">Start Date</label>
                    <input type="date"  min={mindateset} onChange={(e) =>setStart(e.target.value)} id="birthday" name="birthday"/>
                    </div>
                    <div className="col-md-6">
                    <label for="lastname">End Date</label>
                    <input type="date"   min={mindateset} onChange={(e) =>setEnd(e.target.value)} id="birthday" name="birthday"/>
                    </div>
                    <div className="col-md-6">
                    <label for="lastname">Asset ID</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={asset_id}
                        onChange={(e) =>
                            assetentryfn(e)                          
                        }
                        
                        placeholder="Asset ID"
                        required
                         maxlength="12"
                    />
                    </div>
                    <div className="col-md-6">
                    <label> Functional Head</label>
                    <select
                        name="select"
                        id="select"
                        value={selectedrpmanager}
                        onChange={(e) =>callselectedfn(e)}
                    >
                        {/* <option
                                            value=""
                                            disabled
                                            selected={selectedrpmanager === ""}
                                        >
                                            Functional Head
                                        </option> */}
                                        
                                        <option  value={localStorage.getItem('functionheademail')}>{localStorage.getItem('functionheadname')}</option>
                                        {/* <option value="bhaskar.p@switchmobilityev.com">Bhaskar P(Quality)</option>
                                        <option value="sgmani@switchmobilityev.com">Ganesh Mani S(CEO)</option>
                                          <option value="kumaran.s@switchmobilityev.com">Kumaran S(CTO)</option>
                                        <option value="hari.ns@switchmobilityev.com">Hari Nadathur Seshadri(Battery Engg Lead)</option>
                                        <option value="huzefa.ac@switchmobilityev.com">Huzefa A Challawala(PD)</option>
                                        <option value="rao.k@switchmobilityev.com">KNM Rao(Head Engineer)</option>
                                        <option value="ravisankar.s@switchmobilityev.com">Ravi Shankar(Finance)</option>
                                        {/* <option value="mahesh.babu@switchmobilityev.com">Mahesh Babu(CEO)</option> 
                                        <option value="madhu.t@switchmobilityev.com">Madhu T(Legal)</option>
                                        <option value="parthiban.g@switchmobilityev.com">Parthiban G(Manufacturing)</option>
                                        <option value="venkataraman.rg@switchmobilityev.com">RG Venkataraman(Sales & Aftermarket)</option>
                                        <option value="sachin.mehra@switchmobilityev.com">Sachin Mehra(HR)</option>
                                        {/* <option value="sachinnijhawan@switchmobilityev.com">Sachin Nijhawan(Sales & Aftermarket)</option> 
                                        <option value="santhosh.tg@switchmobilityev.com">Santhosh T G(IT)</option>
                                        <option value="shunmugavel.h@switchmobilityev.com">Shunmugavel H(Manufacturing)</option>
                                        <option value="srinivasachandra.v@switchmobilityev.com">Srinivasa Chandra V(Proto& Homol)</option>
                                        <option value="sudhakar.m@switchmobilityev.com">Sudhakar M(Head - LCV)</option>
                                        <option value="tilak.ahuja@switchmobilityev.com">Tilak Raj Ahuja(Sourcing)</option>
                                        <option value="vinothkumar.r@switchmobilityev.com">Vinoth Kumar(PPS)</option> */}
                            
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-12">
                        <hr/>
                    <p style={{fontSize: "10px" }}><strong>Declaration from Requestor </strong><br/><ul>
                        <li style={{textAlign: "left" }}>Activation of USB Port is for legitimate business requirement. I am not getting it activated for my personal use.</li>
                        <li style={{textAlign: "left" }}>I will not make unauthorized copies of data or carry out any activity that compromises confidentiality / integrity / availability of the copied information like copying data in pen drive.</li>
                        <li style={{textAlign: "left" }}>I understand that any illegal/unauthorized use attracts penal actions as defined in HR manual.</li>
                    </ul>	
                    </p>
                    
                    </div> 
                    <div className="row" >
                    <div className="col-md-4" style={{zIndex:"0",width: "16%",marginLeft: "-4%"}}>                  
                    <input id="checkboxs" onChange={(e)=>checkedval(e)}
                        type="checkbox"
                                             
                    /> 
                    </div>
                    <div className="col-md-3" style={{marginLeft:"-15%"}}>      
                      <p for="email">I Agree </p> 
                      </div>
                      
                    </div>
                    </div>
					<div className="text-design-note">Note: Please provide a detailed justification for the access request.</div>
                    <div className="row">
                    <div className="col-md-6">
                    <Button
                        variant="primary"
                        className="btns"
                        type="reset"
                        value="reset"
                        onClick={() => handleReset()}
                    >
                        Clear
                    </Button>
                    </div>
                    <div className="col-md-6">
                    <Button
                    variant="primary"
                      className="btns"
                        type="submit"
                        value="Submit"
                        onClick={(e) => handleSubmit(e)}
                    >
                        Submit
                    </Button>
                    </div>
                    </div>
                </form></div>:selectaccessrequest==="0" & issecondtab?<div className="table-boxs">
                <div className="row">
                    <div className="row ">
                        <div className={isfirsttab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(1)}>Creation</div>  
                        <div className={issecondtab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(2)}>View </div> 
                    </div>
                        {/* <div className="col-md-1"><label htmlFor="switchcode">
                        Search
                        </label></div> */}
                        {/* <div className="col-md-3"><input
                            type="text"
                            name="switchcode"
                            id="switchcode"
                            value={searchdata}
                            onChange={(e) =>
                                searchfunction(e.target.value)
                            }
                            placeholder="Search"
                            required
                        /></div> */}
                        {/* <div className="col-md-1">
                            <Button variant="info" 
                            onClick={() => generatereport()}
                        >
                            <img style={{width: "80%",cursor: "pointer",filter:"invert(1)"}} className="" src={downloadimgbk} title="download"/> 
                        </Button> 
                        </div> */}
                        </div>
                <table className="table-full mt-3">
              <thead className="header-asset">
                <tr>
                  <th>Sl.No</th>
                  <th>Asset ID</th>
                  <th>start Date</th>                              
                  <th>End Date</th>
                  {/* <th>DOJ</th> */}
                  <th>Reason</th>
                  {/* <th>Vendor Name</th> */}
                  {/* <th>Sub Department</th> */}
                  {/* <th>Remarks</th>
                  {/* <th>Manager Employee ID</th> */}
                  {/* <th>Contractor Name</th>
                  <th>Vendor Code</th> */}
                  {/* <th>Verified</th>
                  <th>Status</th>
                  <th>Remarks</th> */}
                   <th>Status</th>
                   <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
              {usblist.length?usblist.map((val, i) => {
                      return (
                        <tr>
                           
                          <td>{i+1}</td>
                          <td>{val.assetid}</td>
                          <td>{val.startdate}</td>
                          <td>{val.enddate}</td>
                          {/* <td>{val.doj}</td>  */}
                          <td>{val.reason}</td>                         
                          {/* <td>{val.sub_department}</td>  */}
                          
                          {/* <td>{val.manager_id}</td>  */}
                          {/* <td>{val.contractor_name}</td> 
                          <td>{val.vendor_code}</td>  
                          <td>{val.verified}</td>
                          <td>{val.status} </td> 
                          <td>{val.remarks}</td>*/}
                            {/* <td style={{width:"15%"}}><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>mailsent(val)} className="" src={sentmail} title="Sent Mail"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>edituser(val)} className="" src={edit} title="Edit"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>removeuser(val)} className="" src={remove} title="Remove"/></td> */}

                          {/* <td style={{cursor:"pointer"}}onClick={(e)=>calllvconnectorselected(e,val)}>edit</td> */}
                           <td>{val.remarks==''?"Submitted":val.remarks}</td>
                           <td>{val.remarks=='Functional Head Approved'?"Pending With IT Head":val.remarks=='IT Head Approved'?'Pending With CEO':val.remarks=='Approved for Access'?'Completed':"Pending with Functional Head"}</td>
                          
                        </tr>
                      );
                    })
                  : ""}
              
              </tbody>
            </table></div>:selectaccessrequest==="1"?<Vpnaccess/>:selectaccessrequest==="2"?<Softwareaccess/>:selectaccessrequest==="4"?<Sharepoint/>:selectaccessrequest==="5"?<Vendormaster/>:''}         
                
            </fieldset>
        </div> 
            </div>
        
        </div>
    );
}


export default Landing;
